import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/tokens.css';
import App from './App';
import PhoneGate from './components/PhoneLanding';
import ApplyPage from './pages/ApplyPage';

// workwith.e3es.com (Duncan 2026-10-27): the application to work with E3, and nothing else of Summit -- no sign-in, no
// phone page (a sub applies from a phone as often as not). On this machine, /apply.
const { hostname, pathname } = window.location;
const PUBLIC_APPLY = /^workwith\./i.test(hostname) || (/^(localhost|127\.0\.0\.1)$/.test(hostname) && pathname.startsWith('/apply'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {PUBLIC_APPLY ? <ApplyPage /> : (
      <BrowserRouter>
        {/* On a phone, a "the Summit app is on the way" page first (Duncan 2026-10-26) */}
        <PhoneGate>
          <App />
        </PhoneGate>
      </BrowserRouter>
    )}
  </React.StrictMode>
);
